import { render, staticRenderFns } from "./RecipientField.vue?vue&type=template&id=17d5186c&scoped=true"
import script from "./RecipientField.ts?vue&type=script&lang=ts&external"
export * from "./RecipientField.ts?vue&type=script&lang=ts&external"
import style0 from "./RecipientField.vue?vue&type=style&index=0&id=17d5186c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d5186c",
  null
  
)

export default component.exports